import { Modal, Switch, TextField } from "@mui/material";
import { React, useEffect, useState } from "react";
import { motion } from "framer-motion";

const EditModal = ({ open, handelModalClose, selectItem, updateItem }) => {
  const [state, setState] = useState({ ...selectItem });

  useEffect(() => {
    setState({ ...selectItem });
  }, [selectItem]);

  const handelSubmit = (e) => {
    e.preventDefault();
    updateItem(state);
  };

  const handelInput = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleSwitchChange = (name) => {
    setState((prevValue) => ({ ...prevValue, [name]: !prevValue[name] }));
  };

  return (
    <Modal
      open={open}
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          height: "85%",
          width: "40%",
          borderRadius: 10,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: "white",
        }}
      >
        <div
          style={{
            height: "95%",
            width: "95%",
            padding: 4,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "80%",
              height: "10%",
              background: "#176B87",
              color: "white",
              borderRadius: "5px 5px 0px 0px ",
            }}
          >
            <p style={{ fontSize: 22, fontWeight: "bolder" }}>
              UPDATE PRICE OF
              <span style={{ color: "orange ", marginLeft: 5 }}>
                "{state.name}"
              </span>
            </p>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "80%",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 8,
            }}
          >
            <p
              style={{
                width: "80%",
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 5,
                boxShadow:
                  "rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px",
              }}
            >
              AUTO BUYING
              {
                <Switch
                  value={state.auto_buying}
                  name="auto_buying"
                  onChange={() => handleSwitchChange("auto_buying")}
                  checked={state.auto_buying}
                />
              }
            </p>
            <p
              style={{
                width: "80%",
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 5,
                boxShadow:
                  "rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px",
              }}
            >
              AUTO SELLING
              {
                <Switch
                  value={state.auto_selling}
                  name="auto_selling"
                  onChange={() => handleSwitchChange("auto_selling")}
                  checked={state.auto_selling}
                />
              }
            </p>
            <p
              style={{
                width: "80%",
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 5,
                boxShadow:
                  "rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px",
              }}
            >
              ROBOT MODE
              {
                <Switch
                  value={state.is_robot_mode}
                  name="is_robot_mode"
                  onChange={() => handleSwitchChange("is_robot_mode")}
                  checked={state.is_robot_mode}
                />
              }
            </p>
            <TextField
              style={{ width: "80%" }}
              type="number"
              name="buying_factor"
              label="BUYING FACTOR"
              variant="outlined"
              onChange={handelInput}
              value={state.buying_factor}
            />
            <TextField
              style={{ width: "80%" }}
              type="number"
              name="buying_restriction_limit"
              label="BUYING RESTRICTION LIMIT"
              variant="outlined"
              onChange={handelInput}
              value={state.buying_restriction_limit}
            />
            <TextField
              style={{ width: "80%" }}
              type="number"
              name="buying_per_drop"
              label="BUYING PER DROP"
              variant="outlined"
              onChange={handelInput}
              value={state.buying_per_drop}
            />
            <TextField
              style={{ width: "80%" }}
              type="number"
              name="bulk_buy_percentage"
              label="BULK BUY PERCENTAGE"
              variant="outlined"
              onChange={handelInput}
              value={state.bulk_buy_percentage}
            />
            <TextField
              style={{ width: "80%" }}
              type="number"
              name="bulk_sell_percentage"
              label="BULK SELL PERCENTAGE"
              variant="outlined"
              onChange={handelInput}
              value={state.bulk_sell_percentage}
            />
          </div>
          <div
            style={{
              height: "10%",
              width: "80%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <motion.button
              style={{
                height: "65%",
                width: "15%",
                color: "#fff",
                border: "none",
                borderRadius: 5,
                fontSize: 12,
                background: "#176B87",
                cursor: "pointer",
              }}
              whileHover={{ background: "#092635", scale: 1.05 }}
              type="submit"
              onClick={handelSubmit}
            >
              UPDATE
            </motion.button>
            <motion.button
              style={{
                height: "65%",
                width: "15%",
                color: "#fff",
                border: "none",
                borderRadius: 5,
                fontSize: 12,
                marginLeft: 15,
                background: "#176B87",
                cursor: "pointer",
              }}
              whileHover={{ background: "#092635", scale: 1.05 }}
              onClick={handelModalClose}
            >
              CLOSE
            </motion.button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditModal;
